import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { NavbarContext } from "../context/NavProvider";
import { CartContext } from "../context/CartProvider";
import {UserProfileContext} from "../context/UserProfileProvider";
import { GeographyContext } from "../context/GeographyProvider";
import { DomainContext } from "../context/DomainProvider";
import { CategoryContext } from "../context/CategoryContext";
import { MiscContext } from "../context/MiscProvider";
export default function useLogout() {
   

  const { setForgotUserIdModalOpen,setDynamicMessageFromApiCall,setPp,clearAuthState,setContactPage,setStateOptions,DPM,setDPM, 
    setPwdAlert,setForgotPasswordModalOpen, setTestimonials, setAlertMessage,  setDocumentsMap,setCompaniesMap,setReceipts, setShowAlert} = useContext(MiscContext);
  const { setLocation,setIPAddress} = useContext(GeographyContext);
  const {setDomainData,setSelectDomains} = useContext(DomainContext);
  const {setCategoryImages,setIsCategoryFormSubmitted,setCategoryId} = useContext(CategoryContext);
  const { setCart, setCartCount, setQty,setCartId, setAddedEntities,setDeliveryDate,setOrders,setOrdersCount,setPaymentInfo} = useContext(CartContext);
  const { setSelectCategories, setBasicOpen, setIsPricing, setIsDark,setAvatar,setBusiness,setPageData} = useContext(NavbarContext);
  const { setAddresses,  setPhones,  setEmails,  setUserProfile ,setUid, setIsLoginRequired,setImages,setTokenLoaded} = useContext(UserProfileContext); 
    const navigate = useNavigate();

    const clearNetworkData = async () => {
        try {
            if ('caches' in window) {
                const cacheKeys = await window.caches.keys();
                await Promise.all(cacheKeys.map(key => window.caches.delete(key)));
            }
            localStorage.removeItem('DOMAIN');
            localStorage.removeItem('FIRM');
            localStorage.removeItem('CART-ID');
            localStorage.removeItem('JWT-TOKEN')
            localStorage.removeItem("cartCount");
            localStorage.removeItem("SUBSCRIPTION");
           // localStorage.clear();
            setBusiness("");
            setDomainData([]);
            setAvatar(undefined);
            setIsLoginRequired(false);           
            setForgotUserIdModalOpen(false);
            setAddedEntities([]);
            setCartId(undefined);
            setTokenLoaded(false);
            setDynamicMessageFromApiCall(undefined);
            setSelectDomains([]);
            setQty(0);
            setPp(false);
            setSelectCategories([]);
            clearAuthState(true);
            setCategoryImages([]);
            setCartCount(0);
            setCategoryId(undefined);
            setAddresses([]);
            setPhones([]);
            setEmails([]);
            setUserProfile(undefined);
            setCart(undefined);
            setOrders([]);
            setContactPage(undefined);
            setUid(undefined);
            setBasicOpen(false);
            setLocation(undefined);
            setPaymentInfo(undefined);
            setIPAddress(undefined);
            setStateOptions(undefined);
            DPM(undefined);
            setDPM(undefined);
            setDeliveryDate(undefined);
            setPageData([]);
            setPwdAlert(false);
            setForgotPasswordModalOpen(false);
            setTestimonials([]);
            setAlertMessage(undefined);
            setIsCategoryFormSubmitted(false);
            setIsPricing(false);            
            setIsDark(false);
            setDocumentsMap({});
            setCompaniesMap({});
            setImages([]);
            setReceipts([]);
            setShowAlert(false);
            setOrdersCount(0);
           
        } catch (error) {
            console.error('Error clearing network data:', error);
        }
    };

    const logout = async () => {
        try {
            const authUrl = process.env.REACT_APP_AUTH_URL;
            const response = await axios.post(`${authUrl}/users/logout`, {}, {
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json",
                },
                withCredentials: true,
            });
            if (response.status === 200) {
                await clearNetworkData();
                // Reset all context-related states
                setDomainData([]);
                setAvatar(undefined);
                setIsLoginRequired(false);
                // More resets...
                navigate('/home', { replace: true });
            }
        } catch (error) {
            console.error('Error while logging out', error);
            await clearNetworkData();
            navigate('/home', { replace: true });
        }
    };

    return logout;
}
